function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        "\n\n  ",
        "\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        "\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        "\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
import React, { PureComponent } from "react";
import propTypes from "prop-types";
import styled from "styled-components";
import { pick, orderBy } from "lodash";
import { TiArrowSortedUp, TiArrowSortedDown } from "react-icons/ti";
import getObjectPath from "../../utils/get-object-path";
import Progress from "../progress";
import makeTableColumnsResizable, { resizeHandleStyles } from "./makeTableColumnsResizable";
var Table = styled.table(_templateObject(), function(param) {
    var theme = param.theme;
    return theme.components.table.base;
}, resizeHandleStyles);
var Th = styled.th(_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.components.table.th;
});
var Td = styled.td(_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.components.table.td;
});
var EmptyTd = styled(Td)(_templateObject3(), function(param) {
    var theme = param.theme;
    return theme.components.table.emptyTd;
});
var disabledRowStyles = {
    pointerEvents: "none",
    filter: "opacity(50%) grayscale(100%)"
};
// Using a component to make it easier to debug
var TRow = function(props) {
    var row = props.row, columns = props.columns, renderCell = props.renderCell, disabledRow = props.disabledRow;
    return /*#__PURE__*/ React.createElement("tr", {
        style: disabledRow ? disabledRowStyles : {}
    }, columns.map(function(col, i) {
        return renderCell(col, i, row);
    }));
};
TRow.propTypes = {
    row: propTypes.object,
    columns: propTypes.array,
    renderCell: propTypes.func,
    disabledRow: propTypes.bool
};
var getCellClassName = function(col, options) {
    var _className = col.className, className = _className === void 0 ? "" : _className;
    if (typeof className === "function") {
        className = className(options, col);
    }
    return className;
};
var getAttributes = function(col, defaultAttributes, options) {
    var ref;
    return ((ref = col.attributes) === null || ref === void 0 ? void 0 : ref.call(col, defaultAttributes, options, col)) || defaultAttributes;
};
var TableContainer = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    _inherits(TableContainer, PureComponent);
    var _super = _createSuper(TableContainer);
    function TableContainer() {
        _classCallCheck(this, TableContainer);
        var _this;
        _this = _super.apply(this, arguments);
        _this.state = {
            sortColumn: undefined,
            sortOrder: "asc"
        };
        _this.tableRef = /*#__PURE__*/ React.createRef();
        _this.updateResizeHandles = function() {};
        _this.handleSort = function(column) {
            var _props, ref;
            var sortOrder = _this.state.sortOrder;
            var sortColumn = column.id;
            if (sortColumn === _this.state.sortColumn) {
                sortOrder = sortOrder === "asc" ? "desc" : "asc";
            } else {
                var defaultSortOrder = column.defaultSortOrder || _this.props.defaultSortOrder;
                if (defaultSortOrder) {
                    sortOrder = defaultSortOrder;
                }
            }
            _this.setState({
                sortColumn: sortColumn,
                sortOrder: sortOrder
            });
            (ref = (_props = _this.props).onSort) === null || ref === void 0 ? void 0 : ref.call(_props, sortColumn, sortOrder);
        };
        _this.renderHeaders = function() {
            var _state = _this.state, sortColumn = _state.sortColumn, sortOrder = _state.sortOrder;
            var _props = _this.props, isTableSortable = _props.isSortable;
            return _this.props.columns.map(function(col, i) {
                var isSortable = col.isSortable && isTableSortable;
                var callbackOptions = {
                    isHeader: true
                };
                var className = getCellClassName(col, callbackOptions);
                var width = col.width, textAlign = col.textAlign;
                return /*#__PURE__*/ React.createElement(Th, _extends({
                    key: i
                }, getAttributes(col, {
                    width: width,
                    textAlign: textAlign,
                    className: className,
                    isSortable: isSortable,
                    onClick: function() {
                        return isSortable && _this.handleSort(col);
                    }
                }, callbackOptions), {
                    "data-testid": "table-th-".concat(col.id)
                }), /*#__PURE__*/ React.createElement("div", {
                    className: "overflow-wrapper"
                }, /*#__PURE__*/ React.createElement("div", {
                    "data-testid": "table-storting",
                    className: "sorting-wrapper"
                }, col.label, isSortable && sortColumn === col.id && ({
                    asc: /*#__PURE__*/ React.createElement(TiArrowSortedUp, null),
                    desc: /*#__PURE__*/ React.createElement(TiArrowSortedDown, null)
                })[sortOrder])));
            });
        };
        _this.renderEmptyRow = function(content) {
            return /*#__PURE__*/ React.createElement("tr", {
                "data-testid": "table-empty-tr"
            }, /*#__PURE__*/ React.createElement(EmptyTd, {
                colSpan: _this.props.columns.length
            }, content));
        };
        _this.renderContent = function() {
            var renderLoader = _this.props.renderLoader;
            if (renderLoader) {
                if (typeof renderLoader === "function") {
                    return renderLoader({
                        renderEmptyRow: _this.renderEmptyRow,
                        renderRows: _this.renderRows
                    });
                } else {
                    return _this.renderEmptyRow(/*#__PURE__*/ React.createElement(Progress, null));
                }
            }
            if (!_this.props.data.length) {
                return _this.renderEmptyRow(_this.props.noDataMessage || "No Data to be displayed");
            }
            return _this.renderRows();
        };
        _this.renderRows = function() {
            var finalData = _this.props.data;
            var sortColumn = _this.state.sortColumn;
            if (sortColumn) {
                var sortOrder = _this.props.sortOrder || _this.state.sortOrder;
                var iteratee = function(param) {
                    var val = param[sortColumn];
                    return typeof val === "string" ? val.toLowerCase() : val;
                };
                finalData = orderBy(finalData, [
                    iteratee
                ], [
                    sortOrder
                ]);
            }
            return finalData.map(function(row) {
                var _props, ref;
                /*#__PURE__*/ return React.createElement(TRow, {
                    key: row[_this.props.keyField],
                    row: row,
                    columns: _this.props.columns,
                    renderCell: _this.renderCell,
                    disabledRow: (ref = (_props = _this.props).shouldDisableRow) === null || ref === void 0 ? void 0 : ref.call(_props, row)
                });
            });
        };
        _this.renderCell = function(col, i, row) {
            var extraProps = _this.props.extraProps;
            var value = col.id ? getObjectPath(row, col.id) : null;
            value = col.formatter ? col.formatter(value, row, {
                extraProps: extraProps
            }) : value;
            var content = col.component ? /*#__PURE__*/ React.createElement(col.component, {
                row: row,
                value: value,
                extraProps: extraProps
            }) : value;
            var callbackOptions = {
                row: row,
                value: value,
                rowIndex: i
            };
            var className = getCellClassName(col, callbackOptions);
            return /*#__PURE__*/ React.createElement(Td, _extends({
                "data-testid": "table-td-".concat(col.id),
                key: i
            }, getAttributes(col, {
                textAlign: col.textAlign,
                className: className
            }, callbackOptions)), content);
        };
        return _this;
    }
    var _proto = TableContainer.prototype;
    _proto.componentDidMount = function componentDidMount() {
        // Currently no support for changing this after initial render
        if (this.props.isResizable && this.tableRef.current) {
            var _this = this;
            makeTableColumnsResizable(this.tableRef.current, this.props.resizeOptions, function(updateResizeHandles) {
                _this.updateResizeHandles = updateResizeHandles;
            });
        }
    };
    _proto.componentDidUpdate = function componentDidUpdate() {
        var ref, ref1;
        (ref = this) === null || ref === void 0 ? void 0 : (ref1 = ref.updateResizeHandles) === null || ref1 === void 0 ? void 0 : ref1.call(ref);
    };
    _proto.render = function render() {
        return /*#__PURE__*/ React.createElement(Table, _extends({
            "data-testid": "table",
            ref: this.tableRef
        }, pick(this.props, "className", "style")), /*#__PURE__*/ React.createElement("thead", null, /*#__PURE__*/ React.createElement("tr", null, this.renderHeaders())), /*#__PURE__*/ React.createElement("tbody", null, this.renderContent()));
    };
    // eslint-disable-next-line no-unused-react-component-methods/no-unused-react-component-methods
    TableContainer.getDerivedStateFromProps = function getDerivedStateFromProps(props, state) {
        var newState = {};
        if (props.sortColumn !== state.prevSortColumn) {
            newState.sortColumn = props.sortColumn;
            newState.prevSortColumn = props.sortColumn;
        }
        if (props.sortOrder !== state.prevSortOrder) {
            newState.sortOrder = props.sortOrder;
            newState.prevSortOrder = props.sortOrder;
        }
        return newState;
    };
    return TableContainer;
}(PureComponent);
TableContainer.propTypes = {
    data: propTypes.array,
    columns: propTypes.arrayOf(propTypes.shape({
        id: propTypes.string,
        label: propTypes.oneOfType([
            propTypes.string,
            propTypes.object
        ]),
        component: propTypes.oneOfType([
            propTypes.node,
            propTypes.func
        ]),
        formatter: propTypes.func,
        isSortable: propTypes.bool,
        className: propTypes.oneOfType([
            propTypes.string,
            propTypes.func
        ]),
        attributes: propTypes.func
    })).isRequired,
    keyField: propTypes.string.isRequired,
    isSortable: propTypes.bool,
    sortColumn: function(props, propName, componentName) {
        if (!props.isSortable) return;
        if (!props.columns.find(function(col) {
            return col.id === props.sortColumn;
        })) {
            return new Error("Invalid prop `" + propName + "` supplied to" + " `" + componentName + "`, expected one of column ids: [" + props.columns.map(function(col) {
                return col.id;
            }).filter(Boolean).join(", ") + "]. Got `" + props.sortColumn + "`");
        }
    },
    sortOrder: propTypes.oneOf([
        "asc",
        "desc"
    ]),
    defaultSortOrder: propTypes.oneOf([
        "asc",
        "desc"
    ]),
    onSort: propTypes.func,
    renderLoader: propTypes.oneOfType([
        propTypes.bool,
        propTypes.func
    ]),
    shouldDisableRow: propTypes.func,
    isResizable: propTypes.bool,
    resizeOptions: propTypes.shape({
        minColWidth: propTypes.number,
        memoryKey: propTypes.string
    }),
    extraProps: propTypes.any
};
TableContainer.defaultProps = {
    isSortable: true,
    defaultSortOrder: null,
    onSort: function onSort() {},
    shouldDisableRow: function() {
        return false;
    },
    isResizable: false
};
export default TableContainer;
